module.exports = __webpack_public_path__ + "img/robinet.1b3750f.svg";